<div
  *ngIf="{ displayProduct: displayProduct$ | async, variantProduct: variantProduct$ | async } as product"
  class="udex-grid udex-mx-auto"
  role="alert">

  <dcp-generic-configurator-error
    imgPath="../../../../assets/images/configurator/configure_restructure_error.png"
    headline="configurator.error.restructure.headline"
    class="udex-mb-20"
  ></dcp-generic-configurator-error>

  <p class="body--s text-center col-12 col-md-7 udex-mx-auto udex-mb-20">
    {{ 'configurator.error.restructure.message1' | cxTranslate }}
    <ng-container *ngIf="isSProductShown">
      <dcp-open-pdp-link
        *ngIf="{ displayProduct: sDisplayProduct$ | async, variantProduct: sVariantProduct$ | async } as sProduct"
        [displayProduct]="sProduct.displayProduct"
        [variantProduct]="sProduct.variantProduct"
      ></dcp-open-pdp-link>
    </ng-container>
    <ng-container *ngIf="!isSProductShown">current contract</ng-container>
    {{ 'configurator.error.restructure.message2' | cxTranslate }}
    {{ product.variantProduct?.name }}{{ 'common.dot' | cxTranslate }}
    {{ 'configurator.error.restructure.message3' | cxTranslate }}
    {{ 'configurator.error.restructure.message4' | cxTranslate }}
    <dcp-contact-us-link innerText="configurator.error.contactUs.supportRequest"></dcp-contact-us-link>
  </p>

  <div class="d-flex udex-mx-auto">
    <udex-button
      (click)="openConfigurator(product.variantProduct)"
      (keydown.enter)="openConfigurator(product.variantProduct)"
      class="udex-button--wide"
      size="Large"
      design="Primary"
      data-cy="cta-btn">
      {{ 'configurator.error.restructure.buttonText2' | cxTranslate }}
    </udex-button>
    <dcp-cancel-cta-button
      class="udex-ms-8"
      [displayProduct]="product.displayProduct"
    ></dcp-cancel-cta-button>
  </div>

</div>
